import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
const IDLE_LIMIT_MS = 30 * 60 * 1000;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("sf_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (!user || user === false) return;
    let timer;
    const lock = () => {
      localStorage.removeItem("sf_token");
      window.location.href = "/login?idle=1";
    };
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(lock, IDLE_LIMIT_MS);
    };
    const events = ["mousemove", "keydown", "click", "touchstart", "scroll"];
    events.forEach((ev) => window.addEventListener(ev, reset, { passive: true }));
    reset();
    return () => {
      clearTimeout(timer);
      events.forEach((ev) => window.removeEventListener(ev, reset));
    };
  }, [user]);

  const completeLogin = (token, userData) => {
    localStorage.setItem("sf_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("sf_token");
    localStorage.removeItem("sf_admin_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, completeLogin, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function homeFor(role) {
  if (role === "aide") return "/aide";
  if (role === "supervisor") return "/supervisor";
  if (role === "tag_admin") return "/admin";
  if (role === "sped_teacher") return "/sped";
  return "/overview";
}
